<template>
    <q-item
        style="margin: 10px 0; border-radius: 10px; border: 1px solid #80808047"
    >
        <q-inner-loading v-if="!order" />
        <template v-else>
            <q-item-section>
                <q-item-label>#{{ order.orderId }}</q-item-label>
                <q-item-label caption>Order date: {{orderDate}}</q-item-label>
                <q-item-label caption
                    >Customer name:
                    {{ order.shipping.shippingFirstName }}</q-item-label
                >
                <q-item-label caption
                    >{{ order.productList.length }} item</q-item-label
                >
                <template v-if="order.payment">
                    <q-item-label caption v-if="order.payment.grandTotal"
                        >Total price:
                        {{ order.payment.grandTotal }}฿</q-item-label
                    >
                </template>
            </q-item-section>

            <div class="column justify-between items-center">
                <template v-if="!order.payment">
                    <template v-if="isExpired">
                        <q-icon
                            name="hourglass_empty"
                            style="font-size: 3rem"
                        />
                        <div class="text-subtitle2">Expired</div>
                    </template>
                    <template v-else>
                        <q-icon
                            name="pending_actions"
                            style="font-size: 3rem"
                            class="text-lime"
                        />
                        <div class="text-subtitle2">Pending</div>
                    </template>
                </template>

                <template v-else>
                    <template v-if="order.payment.isPaid">
                        <q-icon name="check_circle" class="text-green" style="font-size: 3rem" />
                        <div class="text-subtitle2">Paid</div>
                    </template>

                    <template v-else>
                        <template v-if="isExpired">
                            <q-icon
                                name="hourglass_empty"
                                style="font-size: 3rem"
                            />
                            <div class="text-subtitle2">Expired</div>
                        </template>
                        <template v-else>
                            <q-icon
                                name="pending_actions"
                                style="font-size: 3rem"
                                class="text-green"
                            />
                            <div class="text-subtitle2">Pending</div>
                        </template>
                    </template>
                </template>
                <!-- <q-icon
                    :name="
                        order.payment.isPaid == true ? `check_circle` : `cancel`
                    "
                    :class="
                        order.payment.isPaid == true ? `text-green` : `text-red`
                    "
                    style="font-size: 3rem"
                /> -->
                <q-btn
                    no-caps
                    flat
                    color="primary"
                    dense
                    label="View detail"
                    @click="onViewDetail"
                ></q-btn>
            </div>
        </template>
    </q-item>
</template>

<script>
import dayjs from "dayjs";
export default {
    name: "CustomerDetailCard",
    components: {},
    props: ["rtp"],
    data() {
        return {
            selected: true,
            productList: [
                "Product1 name",
                "Product2 name",
                "Product3 name",
                "Product4 name",
            ],
            order: null,
            // order: {
            // }
        };
    },
    computed: {
        isExpired() {
            const exp = dayjs.unix(this.rtp.expirationTime);
            return dayjs().isAfter(exp);
        },
        orderDate(){
            return dayjs.unix(this.rtp.expirationTime).format("DD MMM YYYY")
        }
    },
    mounted() {
        this.loadOrder();
    },
    methods: {
        async loadOrder() {
            console.log(this.order);

            const idToken = await this.$services.authentication.getIdToken();
            this.order = await this.$services.orders.getOrderById(
                this.rtp.orderID,
                idToken
            );
        },
        onEditCustomer() {
            console.log("Edit customer");
        },
        onDeleteCustomer() {
            console.log("Delete customer");
        },
        onViewDetail() {
            // console.log("view order: ", orderId);
            this.$router.push({ name: "OrderDetail", params: { id: this.order.orderId } });
        },
    },
};
</script>

<style scoped>
/*  */
</style>
